import React, { useState } from 'react';
import './ExportButton.css';

/**
 * Reusable Export Button Component
 * @param {Function} onExport - Function to call for export (receives format as parameter)
 * @param {Array} formats - Array of formats to support ['excel', 'csv', 'pdf']
 * @param {string} label - Button label
 * @param {boolean} disabled - Whether button is disabled
 * @param {string} className - Additional CSS classes
 */
const ExportButton = ({ 
  onExport, 
  formats = ['excel', 'csv', 'pdf'],
  label = 'Export',
  disabled = false,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (format) => {
    setIsOpen(false);
    setIsExporting(true);
    
    try {
      await onExport(format);
    } catch (error) {
      console.error('Export failed:', error);
      alert('Export failed. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  const formatIcons = {
    excel: '📊',
    csv: '📄',
    pdf: '📕'
  };

  const formatLabels = {
    excel: 'Excel (.xlsx)',
    csv: 'CSV (.csv)',
    pdf: 'PDF (.pdf)'
  };

  return (
    <div className={`export-button-container ${className}`}>
      <button
        className="export-button"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled || isExporting}
      >
        {isExporting ? (
          <>
            <span className="export-spinner"></span>
            Exporting...
          </>
        ) : (
          <>
            <span className="export-icon">⬇️</span>
            {label}
            <span className="export-arrow">{isOpen ? '▲' : '▼'}</span>
          </>
        )}
      </button>

      {isOpen && !isExporting && (
        <div className="export-dropdown">
          {formats.map(format => (
            <button
              key={format}
              className="export-option"
              onClick={() => handleExport(format)}
            >
              <span className="format-icon">{formatIcons[format]}</span>
              {formatLabels[format]}
            </button>
          ))}
        </div>
      )}

      {isOpen && (
        <div 
          className="export-backdrop" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default ExportButton;


